import GoogleMap from '../blocks/googleMap';
import hero from '../blocks/hero';
import backgroundSlider from '../components/backgroundSlider';
import header from '../components/header';

export default {
  init() {
    // JavaScript to be fired on all pages
    backgroundSlider(),
    GoogleMap.initAll(),
    header(),
    hero()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js